import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';

import { API_HOST } from '../../config/app-const';
import { getUrlParams } from '../../helpers/pagination';

const state = {
  relevancy: {
    isBusy: false,
    data: null,
    error: null,
    historyIsBusy: false,
    last_activities: null,
  }
};

const getters = {
  relevancy: (state) => {
    if (!state.relevancy.data) return [];

    return state.relevancy.data.data.data;
  }
}

const mutations = {
  LOAD_RELEVANCY_BUSY: (state, payload) => {
    state.relevancy.isBusy = payload;
  },
  LOAD_RELEVANCY_SUCCESS: (state, payload) => {
    state.relevancy.data = payload;
    state.relevancy.error = null;
  },
  LOAD_RELEVANCY_FAIL: (state, payload) => {
    state.relevancy.data = null;
    state.relevancy.error = payload;
  },

  CREATE_OR_UPDATE_RELEVANCY_BUSY: (state, payload) => {
    state.relevancy.isBusy = payload;
  },
  CREATE_OR_UPDATE_RELEVANCY_SUCCESS: (state, payload) => {
    state.relevancy.data = payload;
    state.relevancy.error = null;
  },
  CREATE_OR_UPDATE_RELEVANCYY_FAIL: (state, payload) => {
    state.relevancy.data = null;
    state.relevancy.error = payload;
  },

  LOAD_RELEVANCY_HISTORY_BUSY: (state, payload) => {
    state.relevancy.historyIsBusy = payload;
  },
  LOAD_RELEVANCY_HISTORY_SUCCESS: (state, payload) => {
    let currentData = payload.data.pagination.currentPage > 1 ? state.relevancy.last_activities?.data : []
    let payloadData = {data:[...currentData || [], ...payload?.data?.data || []], pagination: payload.data.pagination}
    state.relevancy.last_activities = payloadData;
    state.relevancy.error = null;
  },
  LOAD_RELEVANCY_HISTORY_FAIL: (state, payload) => {
    state.relevancy.last_activities = null;
    state.relevancy.error = payload;
  },
};

const actions = {
  getRelevancy: ({ commit, rootState }, { projectId, type }) => {
    commit('LOAD_RELEVANCY_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };
    let query = '';
    if(type){
      query = `?type=${type}`
    }

    return Axios
      .get(`${API_HOST}/projects/${projectId}/relevancy_settings${query}`, config)
      .then(response => {
        let d = response.data;
        commit('LOAD_RELEVANCY_SUCCESS', {...d, data: d?.data?.[0], dataList: d.data})
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_RELEVANCY_FAIL', error)
      })
      .finally(() => commit('LOAD_RELEVANCY_BUSY', false));
  },

  postRelevancy: ({ commit, rootState }, { projectId, data, relevancyId }) => {
    commit('CREATE_OR_UPDATE_RELEVANCY_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios
      .post(`${API_HOST}/projects/${projectId}/relevancy_settings${relevancyId ? "/" + relevancyId : ""}`, 
      data,
      config)
      .then(response => {
        commit('CREATE_OR_UPDATE_RELEVANCY_SUCCESS', response.data)
        return response.data;
      })
      .catch(error => {
        let msg = error?.response?.data?.message || i18n.t('messages.request.error');
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: msg
        });
        commit('CREATE_OR_UPDATE_RELEVANCYY_FAIL', error)
      })
      .finally(() => commit('CREATE_OR_UPDATE_RELEVANCY_BUSY', false));
  },
  permanentDeleteRelevancyById: ({ commit, rootState }, { projectId, relevancyId }) => {
    commit('CREATE_OR_UPDATE_RELEVANCY_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios
      .delete(`${API_HOST}/projects/${projectId}/relevancy_settings/${relevancyId}`, 
      config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
      })
      .finally(() => commit('CREATE_OR_UPDATE_RELEVANCY_BUSY', false));
  },
  getRelevancyHistory: ({ commit, rootState }, { projectId, relevancyId, pagination }) => {
    commit('LOAD_RELEVANCY_HISTORY_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };
    let query = getUrlParams(pagination);

    return Axios
      .get(`${API_HOST}/projects/${projectId}/relevancy_settings/history${relevancyId ? "/" + relevancyId : ""}?${query}`, config)
      .then(response => {
        commit('LOAD_RELEVANCY_HISTORY_SUCCESS', response.data)
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_RELEVANCY_HISTORY_FAIL', error)
      })
      .finally(() => commit('LOAD_RELEVANCY_HISTORY_BUSY', false));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};